import React, {useEffect, useState} from 'react';
import AdminInterface from "../../layout/AdminInterface";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";
import {
    checkNullArr,
    checkNullJson,
    checkNullStr,
    getJsonValue,
    isBoolTrue,
    isJsonValueTrue,
    limitStringWords,
    parseInteger,
    randomInt,
    setTabTitle
} from "../../../common/fusion-ui/utils/ReactUtils";
import {Flexbox, GridBox, Image, Label, Section, SkeletonBox} from "../../../common/fusion-ui";
import {printError, printLog} from "../../../common/CommonUtils";
import {useTheme} from "../../../common/ProjectThemeProvider";
import {useToast} from "../../../common/fusion-ui/provider/ToastProvider";
import {FramerAnimator} from "../../../common/fusion-ui/animation/FramerAnimator";
import {Doughnut} from "react-chartjs-2";

import {ArcElement, Chart as ChartJS, Legend, Tooltip,} from "chart.js";
import useScreenSize from "../../../common/fusion-ui/hook/useScreenSize";
import {sendAdminRequest} from "../../utils/AdminUtils";
import {CssVariant} from "../../../common/fusion-ui/config/FusionConfig";

// Register the necessary Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);


//https://www.chartjs.org/docs/latest/charts/doughnut.html#doughnut
const DashboardPage = React.memo(() => {
    const TAG = 'DashboardPage';
    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    // const {isOnline} = useInternetStatus();

    const moduleName = AdminModules.Dashboard;
    const animator = new FramerAnimator();
    const {checkScreenWidthWithin} = useScreenSize();

    const LABEL_BGS = [theme.text20, theme.primary20, theme.primaryLight20, theme.primaryDark20, theme.primaryAlt20, theme.primaryAltDark20, theme.primaryAltLight20, theme.primaryBlue20, theme.primaryBlueDark20, theme.primaryBlueLight20, theme.rippleColorXsPrimary,];

    const Fields = {
        isDataFetched: 'isDataFetched',
        isDataLoading: 'isDataLoading',
        dataLoadingMsg: 'dataLoadingMsg',
        isDataFound: 'isDataFound',
    };
    const WidgetFields = {
        mostActiveComps: 'mostActiveComps',
        mostActiveUsers: 'mostActiveUsers',
        activeComps: 'activeComps',
        activeUsers: 'activeUsers',
        activeResources: 'activeResources',
        activities: 'activities',
    };

    const [fieldsData, setFieldsData] = useState({});
    // const [widgetsData, setWidgetsData] = useState(DashboardPageData);
    const [widgetsData, setWidgetsData] = useState({});

    const resGraphOptions = {
        responsive: true, maintainAspectRatio: false, plugins: {
            legend: {
                display: true, position: "right", // marginTop: "2rem",
            }, tooltip: {
                enabled: true, callbacks: {
                    label: function (tooltipItem) {
                        // const label = tooltipItem.label || "";
                        const value = tooltipItem.raw;
                        // return `${label}: ${value}`;
                        return `Count: ${value}`;
                    },
                },
            },
        }, cutout: "50%", // To create a doughnut effect with a bigger center
    };

    useEffect(() => {
        setTabTitle(moduleName);
        fetchWidgetsData();
    }, []);

    return (<AdminInterface moduleName={moduleName} tag={TAG}>
        {/*<div>*/}
        {/*    <div>mostActiveComps: {jsonToStr(getWidgetData(WidgetFields.mostActiveComps))}</div>*/}
        {/*    <div>mostActiveUsers: {jsonToStr(getWidgetData(WidgetFields.mostActiveUsers))}</div>*/}
        {/*    <div>activeComps: {jsonToStr(getWidgetData(WidgetFields.activeComps))}</div>*/}
        {/*    <div>activeUsers: {jsonToStr(getWidgetData(WidgetFields.activeUsers))}</div>*/}
        {/*    <div>activeResources: {jsonToStr(getWidgetData(WidgetFields.activeResources))}</div>*/}
        {/*</div>*/}

        {/*loading*/}
        {/*{renderLoader()}*/}
        {isFieldTrue(Fields.isDataLoading) && renderLoader()}

        {/*rows*/}
        {(isFieldTrue(Fields.isDataFound) && !isFieldTrue(Fields.isDataLoading)) && <div>
            {/*1st-row*/}
            <div className={''}>
                <GridBox className={'px-1 mt-n2'} md={[5, 4, 3]}>
                    {/*most-active-comps*/}
                    {checkWidgetData(WidgetFields.mostActiveComps) && <WidgetSection title={'Most active companies'} bg={theme.text10} maxHeight={'160px'}>
                        {getWidgetData(WidgetFields.mostActiveComps).map((item, index) => {
                            return <div key={index + item.name}>
                                <Flexbox className={`rounded-3 px-2 py-1 w-100x ${index > 0 ? 'mt-1' : ''}`}
                                         bg={'white'} alignAt={'center'} justifyAt={'start'} position={'relative'}>
                                    <Image
                                        wrapperClassName={''}
                                        className={'rounded-3 border-none'}
                                        // src={item.image + 'xx'}
                                        src={item.image}
                                        errorSrc={'https://cdn.pixabay.com/photo/2013/07/12/18/54/star-153971_1280.png'}
                                        width={'20px'}
                                        height={'auto'}
                                        objectFit={'fill'}
                                    />

                                    <Label className={'text-theme-resp text-nowrap ps-2'} bgColor={theme.textWhite} textAt={'start'}
                                           asTag={true} widthClass={'100'} tooltip={(item.name + '').length > 40 ? item.name : ''}>
                                        {limitStringWords(item.name, 40, '', '...')}
                                    </Label>

                                    {checkNullStr(item.total_users) && <Label className={'text-theme-resp text-nowrap fs-md-sm rounded-10 px-1 position-absolute'}
                                                                              tooltip={'Total Users'} bgColor={LABEL_BGS[randomInt(0, LABEL_BGS.length - 1)]}
                                                                              asTag={true} style={{top: '.44rem', right: '.32rem'}}>
                                        {item.total_users}
                                    </Label>}
                                </Flexbox>
                            </div>
                        })}
                    </WidgetSection>}

                    {/*most-active-users*/}
                    {checkWidgetData(WidgetFields.mostActiveUsers) && <WidgetSection title={'Most active users'} bg={theme.text10} maxHeight={'160px'}>
                        {getWidgetData(WidgetFields.mostActiveUsers).map((item, index) => {
                            return <div key={index + item.name}>
                                <Flexbox className={`rounded-3 px-2 py-1 w-100x ${index > 0 ? 'mt-1' : ''}`}
                                         bg={'white'} alignAt={'center'} justifyAt={'start'} position={'relative'}>
                                    <Image
                                        wrapperClassName={''}
                                        className={'rounded-3 border-none'}
                                        // src={item.image + 'xx'}
                                        src={item.image}
                                        errorSrc={'https://cdn.pixabay.com/photo/2012/04/26/19/43/profile-42914_1280.png'}
                                        width={'20px'}
                                        height={'auto'}
                                        objectFit={'fill'}
                                    />

                                    <Label className={'text-theme-resp text-nowrap ps-2'} bgColor={theme.textWhite} textAt={'start'}
                                           asTag={true} widthClass={'100'} tooltip={(item.name + '').length > 26 ? item.name : ''}>
                                        {limitStringWords(item.name, 26, '', '...')}
                                    </Label>

                                    {checkNullStr(item.total_login) && <Label className={'text-theme-resp text-nowrap fs-md-sm rounded-10 px-1 position-absolute'}
                                                                              tooltip={'Total Login'} bgColor={LABEL_BGS[randomInt(0, LABEL_BGS.length - 1)]}
                                                                              asTag={true} style={{top: '.44rem', right: '.32rem'}}>
                                        {item.total_login}
                                    </Label>}
                                </Flexbox>
                            </div>
                        })}
                    </WidgetSection>}

                    {/*active-companies & users*/}
                    <div>
                        {/*active-companies*/}
                        {checkWidgetData(WidgetFields.activeComps, 'json') && <div>
                            <WidgetSection title={'Companies'}>
                                <Flexbox className={``} justifyAt={'between'} wrap={'nowrap'}>
                                    <div className={'w-100'} style={{borderRight: `1.5px ${theme.text30} solid`, paddingRight: '.37rem'}}>
                                        <div><Label className={'text-theme-resp-75 fs-md-lg fw-bold'} widthClass={'100'}>Active</Label></div>
                                        <div><Label className={'text-theme-resp fs-normal'} widthClass={'100'}>
                                            {parseInteger(getWidgetData(WidgetFields.activeComps).active)}</Label>
                                        </div>
                                    </div>

                                    <div className={'w-100'}>
                                        <div><Label className={'text-theme-resp-75 fs-md-lg fw-bold'} widthClass={'100'}>Total</Label></div>
                                        <div><Label className={'text-theme-resp fs-normal'} widthClass={'100'}>
                                            {parseInteger(getWidgetData(WidgetFields.activeComps).total)}</Label>
                                        </div>
                                    </div>
                                </Flexbox>
                            </WidgetSection>
                        </div>}

                        {/*active-users*/}
                        {checkWidgetData(WidgetFields.activeUsers, 'json') && <div className={'mt-2'}>
                            <WidgetSection title={'Users'}>
                                <Flexbox className={``} justifyAt={'between'} wrap={'nowrap'}>
                                    <div className={'w-100'} style={{borderRight: `1.5px ${theme.text30} solid`, paddingRight: '.37rem'}}>
                                        <div><Label className={'text-theme-resp-75 fs-md-lg fw-bold'} widthClass={'100'}>Active</Label></div>
                                        <div><Label className={'text-theme-resp fs-normal'} widthClass={'100'}>
                                            {parseInteger(getWidgetData(WidgetFields.activeUsers).active)}</Label>
                                        </div>
                                    </div>

                                    <div className={'w-100'}>
                                        <div><Label className={'text-theme-resp-75 fs-md-lg fw-bold'} widthClass={'100'}>Total</Label></div>
                                        <div><Label className={'text-theme-resp fs-normal'} widthClass={'100'}>
                                            {parseInteger(getWidgetData(WidgetFields.activeUsers).total)}</Label>
                                        </div>
                                    </div>
                                </Flexbox>
                            </WidgetSection>
                        </div>}
                    </div>
                </GridBox>
            </div>

            {/*2nd-row*/}
            <div className={''}>
                <GridBox className={'px-1 mt-2'} md={[6, 6]}>
                    {/*activities*/}
                    {checkWidgetData(WidgetFields.activities) && <WidgetSection className={'p-1'} title={'Activities'}>
                        <GridBox className={'px-2'} md={4} sm={6} xs={6} gapX={0} gapY={0}>
                            {getWidgetData(WidgetFields.activities).map((item, index) => {
                                return checkNullArr(item.data) && <div key={index + item.label} className={''}>
                                    <WidgetSection title={`${item.label}`} className={'border-0-5 app-section'} roundedVariant={'x'} bg={'x'} borderless={false}
                                                   titleClassName={'text-theme fw-semi-bold text-nowrap'} borderColor={theme.text20}
                                                   style={{borderRadius: checkScreenWidthWithin(754) ? '.5rem' : item.radius}}>
                                        <div className={'mt-n1'}>
                                            {item.data.map((countItem, countIndex) => (<div key={countIndex} className={'fs-sm'}>
                                                {/*{countIndex > 0 && <HorDiv className={'mt-0 mb-0'} variant={theme.text40}/>}*/}
                                                <Label className={'text-theme-resp text-nowrap'}>
                                                    <span className={'fw-bold text-theme-resp-75'}>{countItem.label}: </span>
                                                    <span className={''}>{countItem.count}</span>
                                                </Label>
                                            </div>))}
                                        </div>
                                    </WidgetSection>
                                </div>
                            })}
                        </GridBox>
                    </WidgetSection>}

                    {checkWidgetData(WidgetFields.activeResources, 'json') && <WidgetSection className={'p-1 h-100'}
                                                                                             title={`Available Resources (${getJsonValue(getWidgetData(WidgetFields.activeResources), 'total')})`}>
                        <div className={'w-100 d-flex jc-start h-100 al-center'}>
                            <Doughnut className={''}
                                      style={{height: '200px'}}
                                      options={resGraphOptions}
                                      data={getWidgetData(WidgetFields.activeResources)}
                            />
                        </div>
                    </WidgetSection>}
                </GridBox>
            </div>
        </div>}
    </AdminInterface>);

    function renderLoader() {
        return <div className={'w-100'}>
            {/*1st row*/}
            <div className={''}>
                <GridBox className={'px-1 mt-n2'} md={[5, 4, 3]}>
                    {[1, 2].map((item) =>
                        <Section className={'w-100 px-3 py-2'} bg={theme.text10} key={item + 'pp'} roundedVariant={3} borderless={true}>
                            <SkeletonBox className={'px-5 py-1 mt-1'} bg={theme.text10}/>
                            <div>
                                {[1, 2, 3, 4, 5, 6].map((item) =>
                                    <SkeletonBox className={'w-100 py-2 mt-1'} bg={theme.text10} key={item + 'mm'}/>
                                )}
                            </div>
                        </Section>
                    )}

                    <div>
                        {[1, 2].map((item, index) =>
                            <Section className={`w-100 px-3 py-2 ${index > 0 ? 'mt-2' : ''}`}
                                     shadowVariant={'xs'} roundedVariant={3} borderless={true} key={item + 'zz'}>
                                <SkeletonBox className={'px-4 py-1 mt-1'} bg={theme.text10}/>
                                <Flexbox>
                                    {[1, 2].map((rItem, rIndex) =>
                                        <div className={`w-100 pe-1x ${rIndex % 2 == 0 ? 'pe-2' : 'ps-2'}`} key={rIndex + 'll'}>
                                            <SkeletonBox className={'w-100 py-2 pt-3 mt-1'} bg={theme.text10}/>
                                            <SkeletonBox className={'w-100 py-1 pt-2 mt-1'} bg={theme.text10}/>
                                        </div>
                                    )}
                                </Flexbox>
                            </Section>
                        )}
                    </div>
                </GridBox>
            </div>

            {/*2nd row*/}
            <div className={''}>
                <GridBox className={'px-1 mt-1'} md={6}>
                    <Section className={'w-100 px-3 py-2'} shadowVariant={'xs'} roundedVariant={3} borderless={true}>
                        <SkeletonBox className={'px-5 py-1'} bg={theme.text10}/>
                        <GridBox className={'px-1 mt-1'} md={4} gapY={0}>
                            {[1, 2, 3, 4, 5, 6].map((item) => (
                                <Section className={'w-100 px-3 py-2 border-0-5'} borderColor={theme.text10} roundedVariant={3} key={item + 'll'}>
                                    {[1, 2, 3].map((item) =>
                                        <div className={'w-100'} key={item}>
                                            <SkeletonBox className={`w-100x px-${item + 2} py-1`} bg={theme.text10} key={item + 'aa'}/>
                                        </div>
                                    )}
                                </Section>))}
                        </GridBox>
                    </Section>

                    <Section className={'w-100 px-3 py-2'} shadowVariant={'xs'} roundedVariant={3} borderless={true}>
                        <SkeletonBox className={'px-5 py-1'} bg={theme.text10}/>
                        <GridBox className={'px-1'} md={6}>
                            <SkeletonBox className={'w-100 h-100 py-5'} bg={theme.text10}/>
                            <div className={'ps-1 w-100'}>
                                {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
                                    <SkeletonBox className={'w-100 py-1 mt-1'} bg={theme.text10} key={item}/>
                                ))}
                            </div>
                        </GridBox>
                    </Section>
                </GridBox>
            </div>
        </div>
    }

    function fetchWidgetsData(checkBefore = true) {
        const fun = 'fetchWidgetsData:';
        if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isDataFetched))) {
            try {
                updateField(Fields.isDataFetched, true);
                updateField(Fields.isDataFound, false);
                updateField(Fields.isDataLoading, true);
                updateField(Fields.dataLoadingMsg, "");

                //send-request
                const REQUEST_OPTIONS = {};
                sendAdminRequest({
                    reqUrl: AdminReqUrls.admin__dashboard__fetchWidgetsData,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: (fetchedData => {
                        log(fun, 'fetchedData:', fetchedData);

                        const fetchedWidgetsData = getJsonValue(fetchedData, 'data', {});
                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');

                        updateField(Fields.isDataFound, success);
                        if (success) {
                            // toast(message, CssVariant.success);
                            setWidgetsData(fetchedWidgetsData);
                        } else {
                            toast(message, CssVariant.danger);
                            updateField(Fields.dataLoadingMsg, message);
                        }
                        updateField(Fields.isDataLoading, false);
                    }),
                    onError: ((error) => {
                        logErr(fun, error);
                        updateField(Fields.dataLoadingMsg, `Couldn't load widgets, please try again!'`);
                        updateField(Fields.isDataFound, false);
                        updateField(Fields.isDataLoading, false);
                    }),
                });
            } catch (error) {
                logErr(fun, error);
                updateField(Fields.dataLoadingMsg, `Couldn't load widgets, please try again!'`);
                updateField(Fields.isDataFound, false);
                updateField(Fields.isDataLoading, false);
            }
        }
    }


    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function getWidgetData(field, defValue) {
        return getJsonValue(widgetsData, field, defValue);
    }

    /**
     * Check if specified widget-data is available.
     * @param {string} field - The name of the widget-field to check.
     * @param {'array' | 'json'} [checkType="array"] - The type of widget data to check (either "array" or "json").
     * @return {boolean} - Returns true if data is found otherwise false.
     */
    function checkWidgetData(field, checkType = 'array') {
        if (checkType === 'array') {
            return checkNullArr(getWidgetData(field))
        } else if (checkType === 'json') {
            return checkNullJson(getWidgetData(field));
        } else {
            return false
        }
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
});

const WidgetSection = React.memo(({
                                      title,
                                      className = '',
                                      titleClassName = '',
                                      borderless = true,
                                      children,
                                      bg = '',
                                      borderColor = '',
                                      maxHeight = '',
                                      roundedVariant = 3,
                                      style = {},
                                  }) => {
    return <Section className={`p-0 h-100 ${className}`}
                    bg={bg}
                    borderless={borderless}
                    borderColor={borderColor}
                    shadowVariant={checkNullStr(bg) ? '' : 'xs'}
                    roundedVariant={roundedVariant}
                    title={title}
                    titleClassName={`px-3 pt-2 fw-normal fs-sm-md text-theme-resp-90 ${titleClassName}`}
                    headerClassName={'w-100'}
                    titleAt={'start'}
                    style={style}>
        <div className={'px-3 pb-2 h-100 pt-1 fs-md scroller scroller-y-auto scroll-dark'}
             style={{maxHeight}}>
            {children}
        </div>
    </Section>
});

export default DashboardPage;
